// components/Overlays/index.js

import Overlays from './Overlays';

export default Overlays;
